import { render, staticRenderFns } from "./ADepartamentos.vue?vue&type=template&id=2c2a79fb"
import script from "./ADepartamentos.vue?vue&type=script&lang=js"
export * from "./ADepartamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports